/**
 * Old Manager company SPA (:8080) is invite-only.
 * Carly-direct accounts must not enter SE onboarding via SSO.
 */

const MANAGER_INVITE_SIGNUP_SOURCES = new Set([
  "subscription_invite",
  "company_email_invite",
  "legacy",
]);

export function isCarlySignupSource(
  signupSource: string | null | undefined
): boolean {
  return (signupSource ?? "").trim().toLowerCase() === "carly";
}

export function isManagerInviteSignupSource(
  signupSource: string | null | undefined
): boolean {
  const src = (signupSource ?? "").trim().toLowerCase();
  return MANAGER_INVITE_SIGNUP_SOURCES.has(src);
}
